module.exports = __webpack_public_path__ + "img/3437b76be45150412ad92ca2703fd7a4.svg";